var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal-large-image"},[_c('img',{class:_vm.image,attrs:{"src":_vm.imagePath}})])}
var staticRenderFns = []

export { render, staticRenderFns }